export default {
  workOrder: {
    WorkOrderWrite: '服务工单填写',
    ServiceTime: '服务时间',
    ServiceTutor: '服务导师',
    CommunicationContent: '沟通内容',
    UndoneBusiness: '未完成事项',
    Coupon: '优惠券',
    HasBeenSent: '已发',
    NotSentYet: '未发',
    MemberLabel: '会员标签',
    JointSales: '连带销售',
    RepurchaseTime: '复购时间',
    ReasonOfLoss: '流失原因',
    ChangeToBreastfeeding: '改为母乳喂养',
    PhysicalReasons: '体质原因',
    ChangeToAnotherBrand: '已转牌',
    DrinkMilkUntilDinner: '吃饭不喝奶粉了',
    ResidenceMigration: '居住地迁移',
    AsGift: '送人的',
    Other: '其他'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/myg/serviceWorkOrder.js